import React from "react";
import "./Requirement_Data.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";
import { Container } from "react-bootstrap";

const requirements = [
  {
    title: "General Eligibility",
    type: "check",
    items: [
      "Indian citizen with valid passport",
      "Minimum age 18, maximum as per job role",
      "Good health and medical fitness",
      "Clean police record and background clearance",
      "Willingness to work in international environment",
    ],
  },
  {
    title: "Professional Qualifications",
    type: "check",
    items: [
      "Required educational credentials for position",
      "Minimum work experience as specified",
      "Relevant certifications and licenses",
      "Language proficiency as needed",
      "Technical skill assessment clearance",
    ],
  },
  {
    title: "Documentation Needed",
    type: "dot",
    items: [
      "Valid passport (6+ months validity)",
      "Educational certificates and transcripts",
      "Work experience letters",
      "Professional certifications",
      "Medical fitness report",
      "Police clearance certificate (PCC)",
      "Passport size photographs",
    ],
  },
];

const process = [
  {
    title: "Processing Time",
    description: "30-45 days from application to deployment",
  },
  {
    title: "Visa Support",
    description: "Complete visa processing and documentation assistance",
  },
  {
    title: "Pre-Departure",
    description: "Orientation and guidance before international travel",
  },
  {
    title: "Post-Arrival",
    description: "On-ground support and onboarding assistance",
  },
];

const RequirementData = () => {
  return (
    <section className="requirements">
      {/* <div className="requirements_heading">
        <span className="requirements_badge">JOB REQUIREMENTS</span>

        <h2>Everything you need to get started</h2>

        <p>
          Review the eligibility, professional qualifications, documentation,
          and complete application process.
        </p>
      </div> */}

      <Container>
        <CommonHeading
          badge="job requirements"
          title="Everything you need to get started"
          description="      Review the eligibility, professional qualifications, documentation,
          and complete application process."
        />

        <div className="requirements_grid">
          {requirements.map((section, index) => (
            <div className="requirements_card" key={section.title}>
              <div className="requirements_card_top">
                <span className="requirements_number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <h3>{section.title}</h3>
              </div>

              <ul className={`requirements_list ${section.type}`}>
                {section.items.map((item) => (
                  <li key={item}>
                    <span className="requirements_marker">
                      {section.type === "check" ? "✓" : "•"}
                    </span>

                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="requirements_card timeline_card">
            <div className="requirements_card_top">
              <span className="requirements_number">04</span>

              <h3>Visa &amp; Process Timeline</h3>
            </div>

            <div className="requirements_timeline">
              {process.map((item) => (
                <div className="requirements_step" key={item.title}>
                  <span className="requirements_step_dot"></span>

                  <div className="requirements_step_content">
                    <strong>{item.title}</strong>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default RequirementData;
